(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-seen-in-landing-old"]) return;
  try {
    
$(window).on('load', function() {

$('.as-seen-in .items').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 7,
  slidesToScroll: 7,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }
  ]
});
 
$('.quote-product .items').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true

      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false

      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-seen-in-landing"]) return;
  try {
    
$(window).on('load', function() {

$('.as-seen-in .items').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 7,
  slidesToScroll: 7,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }
  ]
});
 
$('.quote-product .items').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true

      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false

      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-seen-in"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {


$('.as-seen-in .items').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 7,
  slidesToScroll: 7,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-carousel-body-wash"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.before-after .ba-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-carousel-cleanser"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.before-after .ba-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-carousel-mask"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.before-after .ba-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-carousel-serum"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.before-after .ba-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-carousel-shampoo"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.before-after .ba-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-carousel-vitamin"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.before-after .ba-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-carousel"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.before-after .ba-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    
$('.product-list .product-block:last-child').hide();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-PDRN"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-active01"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-age"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-biome"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-body-cream"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-bodywash"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-exo-mask"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-exosome"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-eye"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-lip"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-mask"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-new"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-renewal-mask"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-resurfacing-mask"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-retinal_mlv10"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-retinal_mlv5"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-revive-bodywash"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-revive-conditioner"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-revive-shampoo"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-serum"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-shampoo"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-supercharger"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-synbiotic"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-vitamin"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.customer-product .quote-items').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		adaptiveHeight: true,
  		dots: true,
		arrows: false



      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {


$('.featured-products .product-list').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
 		 arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
 		 arrows: false

      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {


$('.instagram-section .items').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured-press-mask"]) return;
  try {
    

$('.press-wrap').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured-press"]) return;
  try {
    

$('.press-wrap').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-PDRN"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-active01"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-age"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-biome"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-body-cream"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-bodywash"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-exo-mask"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-exosome"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-eye"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-genobiome"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-guasha"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-lip"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-mask"]) return;
  try {
    

 $('.modal_link').on('click', function(){
    var this_modal = '#' + $(this).data('modal');
    $(this_modal).css('display','block');
    $('#site-control').css('display','none');
  });

  $('.modal').on('click', function(){
    $(this).css('display','none');
    $('#site-control').css('display','block');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-new"]) return;
  try {
    

 $('.modal_link').on('click', function(){
    var this_modal = '#' + $(this).data('modal');
    $(this_modal).css('display','block');
    $('#site-control').css('display','none');
  });

  $('.modal').on('click', function(){
    $(this).css('display','none');
    $('#site-control').css('display','block');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-renewal-mask"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-resurfacing-mask"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-retinal_mlv10"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-retinal_mlv5"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-revive-bodywash"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-revive-conditioner"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-revive-shampoo"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-serum"]) return;
  try {
    

 $('.modal_link').on('click', function(){
    var this_modal = '#' + $(this).data('modal');
    $(this_modal).css('display','block');
    $('#site-control').css('display','none');
  });

  $('.modal').on('click', function(){
    $(this).css('display','none');
    $('#site-control').css('display','block');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-shampoo"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-supercharger"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-synbiotic"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-testproduct"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-trial-kit"]) return;
  try {
    
  
   $('.modal_link').on('click', function(){
      var this_modal = '#' + $(this).data('modal');
      $(this_modal).css('display','block');
      $('#site-control').css('display','none');
    });
  
    $('.modal').on('click', function(){
      $(this).css('display','none');
      $('#site-control').css('display','block');
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-vitamin"]) return;
  try {
    

 $('.modal_link').on('click', function(){
    var this_modal = '#' + $(this).data('modal');
    $(this_modal).css('display','block');
    $('#site-control').css('display','none');
  });

  $('.modal').on('click', function(){
    $(this).css('display','none');
    $('#site-control').css('display','block');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info"]) return;
  try {
    

 $('.modal_link').on('click', function(){
    var this_modal = '#' + $(this).data('modal');
    $(this_modal).css('display','block');
  });

  $('.modal').on('click', function(){
    $(this).css('display','none');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredient-detail-new"]) return;
  try {
    
	$(".hydration-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-hydration").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)
	$(".free-radicals-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-free-radicals").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)
	$(".wrinkles-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-wrinkles").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".elasticity-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-elasticity").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".firmness-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-firmness").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".balance-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-balance").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".radiance-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-radiance").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	

	$(".exfoliation-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-exfoliation").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredient-detail-serum"]) return;
  try {
    
	$(".hydration-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-hydration").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)
	$(".free-radicals-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-free-radicals").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)
	$(".wrinkles-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-wrinkles").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".elasticity-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-elasticity").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".firmness-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-firmness").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".balance-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-balance").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".radiance-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-radiance").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	

	$(".exfoliation-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-exfoliation").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredient-detail-vitamin"]) return;
  try {
    
	$(".hydration-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-hydration").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)
	$(".free-radicals-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-free-radicals").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)
	$(".wrinkles-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-wrinkles").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".elasticity-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-elasticity").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".firmness-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-firmness").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".balance-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-balance").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".radiance-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-radiance").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	

	$(".exfoliation-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-exfoliation").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients-detail-mask"]) return;
  try {
    
	$(".hydration-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-hydration").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)
	$(".free-radicals-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-free-radicals").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)
	$(".wrinkles-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-wrinkles").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".elasticity-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-elasticity").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".firmness-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-firmness").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".balance-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-balance").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".radiance-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-radiance").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients-detail"]) return;
  try {
    

	$(".hydration-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-hydration").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)
	$(".free-radicals-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-free-radicals").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)
	$(".wrinkles-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-wrinkles").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".elasticity-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-elasticity").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".firmness-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-firmness").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".balance-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-balance").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	
	$(".radiance-list").hover(
		function(){ $(".ingredient-images li").addClass('hover');$(".ingredient-radiance").removeClass('hover') },
		function(){ $(".ingredient-images li").removeClass('hover') }
	)	



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients-mask"]) return;
  try {
    

  $('.product-ingredients .slideshow').slick({
    autoplay: true,
    fade: true,
    infinite: true,
    useTransform: true,
    arrows: true,
    dots: true,
    autoplaySpeed: 4000,
    adaptiveHeight: false,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          fade: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          fade: false,
          arrows: false,
          dots: true,
          lazyLoad: $(this).find('[data-lazy]').length > 0 ? 'progressive' : null
        }
      }
    ]
  });
  
  $('.slideshow').on('click', function(){
    $(this).slick('slickNext');
  });


  $('.modal_link').on('click', function(){
    var this_modal = '#' + $(this).data('modal');
    $(this_modal).css('display','block');
    $('#site-control').css('display','none');
  });

  $('.modal').on('click', function(){
    $(this).css('display','none');
    $('#site-control').css('display','block');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients-new"]) return;
  try {
    

  $('.product-ingredients .slideshow').slick({
    autoplay: true,
    fade: true,
    infinite: true,
    useTransform: true,
    arrows: true,
    dots: true,
    autoplaySpeed: 4000,
    adaptiveHeight: false,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          fade: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          fade: false,
          arrows: false,
          dots: true,
          lazyLoad: $(this).find('[data-lazy]').length > 0 ? 'progressive' : null
        }
      }
    ]
  });
  
  $('.slideshow').on('click', function(){
    $(this).slick('slickNext');
  });


  $('.modal_link').on('click', function(){
    var this_modal = '#' + $(this).data('modal');
    $(this_modal).css('display','block');
    $('#site-control').css('display','none');
  });

  $('.modal').on('click', function(){
    $(this).css('display','none');
    $('#site-control').css('display','block');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients-serum"]) return;
  try {
    

  $('.product-ingredients .slideshow').slick({
    autoplay: true,
    fade: true,
    infinite: true,
    useTransform: true,
    arrows: true,
    dots: true,
    autoplaySpeed: 4000,
    adaptiveHeight: false,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          fade: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          fade: false,
          arrows: false,
          dots: true,
          lazyLoad: $(this).find('[data-lazy]').length > 0 ? 'progressive' : null
        }
      }
    ]
  });
  
  $('.slideshow').on('click', function(){
    $(this).slick('slickNext');
  });


  $('.modal_link').on('click', function(){
    var this_modal = '#' + $(this).data('modal');
    $(this_modal).css('display','block');
    $('#site-control').css('display','none');
  });

  $('.modal').on('click', function(){
    $(this).css('display','none');
    $('#site-control').css('display','block');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients-vitamin"]) return;
  try {
    

  $('.product-ingredients .slideshow').slick({
    autoplay: true,
    fade: true,
    infinite: true,
    useTransform: true,
    arrows: true,
    dots: true,
    autoplaySpeed: 4000,
    adaptiveHeight: false,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          fade: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          fade: false,
          arrows: false,
          dots: true,
          lazyLoad: $(this).find('[data-lazy]').length > 0 ? 'progressive' : null
        }
      }
    ]
  });
  
  $('.slideshow').on('click', function(){
    $(this).slick('slickNext');
  });


  $('.modal_link').on('click', function(){
    var this_modal = '#' + $(this).data('modal');
    $(this_modal).css('display','block');
    $('#site-control').css('display','none');
  });

  $('.modal').on('click', function(){
    $(this).css('display','none');
    $('#site-control').css('display','block');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients"]) return;
  try {
    

  $('.product-ingredients .slideshow').slick({
    autoplay: true,
    fade: true,
    infinite: true,
    useTransform: true,
    arrows: true,
    dots: true,
    autoplaySpeed: 4000,
    adaptiveHeight: false,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          fade: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          fade: false,
          arrows: false,
          dots: true,
          lazyLoad: $(this).find('[data-lazy]').length > 0 ? 'progressive' : null
        }
      }
    ]
  });
  
  $('.slideshow').on('click', function(){
    $(this).slick('slickNext');
  });


  $('.modal_link').on('click', function(){
    var this_modal = '#' + $(this).data('modal');
    $(this_modal).css('display','block');
    $('#site-control').css('display','none');
  });

  $('.modal').on('click', function(){
    $(this).css('display','none');
    $('#site-control').css('display','block');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-landing-test-old"]) return;
  try {
    

 $('.modal_link').on('click', function(){
    var this_modal = '#' + $(this).data('modal');
    $(this_modal).css('display','block');
  });

  $('.modal').on('click', function(){
    $(this).css('display','none');
    $('#site-control').css('display','block');
  });

 $('.terms_link').on('click', function(){
    var this_modal = '#' + $(this).data('modal');
    $(this_modal).css('display','block');
  });

  $('.modal').on('click', function(){
    $(this).css('display','none');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-landing-test"]) return;
  try {
    

 $('.modal_link').on('click', function(){
    var this_modal = '#' + $(this).data('modal');
    $(this_modal).css('display','block');
  });

  $('.modal').on('click', function(){
    $(this).css('display','none');
    $('#site-control').css('display','block');
  });

 $('.terms_link').on('click', function(){
    var this_modal = '#' + $(this).data('modal');
    $(this_modal).css('display','block');
  });

  $('.modal').on('click', function(){
    $(this).css('display','none');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-landing"]) return;
  try {
    

 $('.modal_link').on('click', function(){
    var this_modal = '#' + $(this).data('modal');
    $(this_modal).css('display','block');
    $('#site-control').css('display','none');
  });

  $('.modal').on('click', function(){
    $(this).css('display','none');
    $('#site-control').css('display','block');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    

  $('.theme-gallery .slideshow').slick({
    autoplay: true,
    fade: true,
    infinite: true,
    useTransform: true,
    arrows: true,
    dots: true,
    autoplaySpeed: 3000,
    adaptiveHeight: false,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          fade: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          fade: false,
          arrows: false,
          dots: true,
          lazyLoad: $(this).find('[data-lazy]').length > 0 ? 'progressive' : null
        }
      }
    ]
  });





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-PDRN"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-active01"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-age"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-biome"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-body-cream"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-bodywash"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {


$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-exo-mask"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-exosome"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-eye"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-lip"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-mask"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {


$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-new"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {


$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-renewal-mask"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-resurfacing-mask"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-retinal_mlv10"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-retinal_mlv5"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-revive-bodywash"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {


$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-revive-conditioner"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-revive-shampoo"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-serum"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {


$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-shampoo"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {


$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-supercharger"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-synbiotic"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-testproduct"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {

$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-vitamin"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {


$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-with-product"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {


$('.quote-product .items').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 2,
 		adaptiveHeight: true,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
 		adaptiveHeight: true,
  		dots: true


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
 		adaptiveHeight: true,
  		dots: true,
		arrows: false


      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function() {


$('.quote-wrap .quote .items').slick({
  dots: false,
  infinite: true,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
  		dots: true,
		arrows: false
      }
    }
  ]
});
  });

  } catch(e) { console.error(e); }
})();
})();
